/** Arrowheads an edge can end in (v11 names). */
export enum MarkerType {
  Arrow = 'arrow',
  ArrowClosed = 'arrowclosed',
}

/** An arrowhead with its look; sizes are in multiples of the edge's stroke width (v11 `EdgeMarker`). */
export type EdgeMarker = {
  type: MarkerType;
  color?: string;
  width?: number;
  height?: number;
  strokeWidth?: number;
};

/** What `markerStart` / `markerEnd` accept: a marker object, or the id of an SVG `<marker>` the app renders itself. */
export type EdgeMarkerType = string | EdgeMarker;
